<template>
  <div
    class="relative flex justify-center items-center overflow-hidden"
    :style="{'height': windowHeight + 'px'}"
  >
    <div
      class="absolute top-0 left-0 w-full h-full -z-1 has-hover:bg-fixed bg-center bg-cover"
      :style="{'background-image': `url('${img}')`}"
    />
    <div class="w-full">
      <div class="relative w-full text-center text-0">
        <div class="relative inline-block w-full sm:w-4/5 sm:max-w-1024">
          <picture>
            <source srcset="../assets/images/kv-m.png" media="(max-width: 639px)">
            <img
              src="../assets/images/kv.png"
              alt="城市永續,再造新局"
              class="w-full sm:m-auto sm:px-6 sm:mb-4"
            />
          </picture>
          <img src="../assets/images/kv-l.png" alt="" class="none sm:block absolute left-0 bottom-0 transform -translate-x-full">
          <img src="../assets/images/kv-r.png" alt="" class="none sm:block absolute right-0 bottom-0 transform translate-x-full">
        </div>
      </div>
      <div class="relative w-full bg-green py-2">
        <picture>
          <source srcset="../assets/images/kv-title-m.png" media="(max-width: 767px)">
          <img class="m-auto sm:max-w-4/5 xl:max-w-max" src="../assets/images/kv-title.png" alt="2021 SDGs 台灣最強城市即將出爐" />
        </picture>
        <ul class="absolute flex w-full h-2 left-0 bottom-0 transform translate-y-full">
          <li
            v-for="item in colorbar"
            :key="item.index"
            class="w-1/16"
            :style="{'background': item}"
          />
        </ul>
      </div>
      <article class="w-11/12 md:w-full text-center mx-auto mt-8 md:mt-12 tracking-normal md:tracking-widest font-semibold">
        <p class="mb-2 md:mb-4">疫情對城市SDGs永續目標造成前所未有的挑戰，</p>
        <p class="mb-2 md:mb-4">貧富差距擴大、線上教學凸顯的數位落差、經濟重挫...等，</p>
        <p class="mb-2 md:mb-4">種種難題不僅考驗城市首長的治理能力，</p>
        <p>也挑戰城市的韌性復原力。</p>
      </article>
    </div>
    <IcoScrollDown
      class="absolute left-1/2 bottom-4 md:bottom-8 transform -translate-x-1/2 sm:hidden md:block"
      color="#94b57c"
      :size="windowWidth > 480 ? 30 : 25"
    />
  </div>
</template>

<script>
import IcoScrollDown from './models/IcoScrollDown'
import backgroundImage from '../assets/images/kvbackground.png'

export default {
  name: 'Kvarea',
  components: {
    IcoScrollDown
  },
  data() {
    return {
      windowWidth: null,
      windowHeight: null,
      img: backgroundImage,
      colorbar: [
        "#e5233d",
        "#dda73a",
        "#4ca146",
        "#c7212f",
        "#ef402d",
        "#27bfe6",
        "#fbc412",
        "#a31c44",
        "#f26a2e",
        "#e01483",
        "#f89d2a",
        "#bf8d2c",
        "#407f46",
        "#1f97d4",
        "#59ba47",
        "#136a9f",
      ]
    }
  },
  methods: {
    checkScreen() {
      const clientWidth = document.documentElement.clientWidth;
      if(clientWidth !== this.windowWidth) {
        this.windowWidth = clientWidth;
        this.windowHeight = document.documentElement.clientHeight;
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.checkScreen);
    this.checkScreen();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreen);
  }
}
</script>
